import axios from "axios";

const BASE_URL = ``;

/**
 * Serwis do komunikacji z API - endpoint /client
 */
export const AuthService = {
  login,
  refreshToken,
  getUserData,
  logout,
  checkLink,
  setPassword,
  sendForgotPasswordEmail,
  resetPassword,
};

function login(data) {
  return axios.post(`${BASE_URL}/login`, data);
}

function refreshToken() {
  return axios.post(`${BASE_URL}/token/refresh`);
}

function getUserData() {
  return axios.get(`${BASE_URL}/authorized/client`);
}

function logout() {
  return axios.post(`${BASE_URL}/logout`);
}

function checkLink(hash) {
  return axios.post(`${BASE_URL}/check-link/${hash}`);
}

function setPassword(data, client) {
  return axios.post(`${BASE_URL}/set-password/${client}`, data);
}

function sendForgotPasswordEmail(data) {
  return axios.post(`${BASE_URL}/forgot-password`, data);
}

function resetPassword(data) {
  return axios.post(`${BASE_URL}/reset-password`, data);
}